define("settings/routes/overview/preferences", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/routing/route", "@ember/service", "ember-concurrency", "shared/utils/constants/days"], function (_exports, _asyncArrowRuntime, _route, _service, _emberConcurrency, _days) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/routing/route",0,"@ember/service",0,"ember-concurrency",0,"shared/utils/constants/days"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let PreferencesRoute = _exports.default = (_class = class PreferencesRoute extends _route.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "router", _descriptor4, this);
      _initializerDefineProperty(this, "settings", _descriptor5, this);
      _initializerDefineProperty(this, "userConfig", _descriptor6, this);
      _defineProperty(this, "handleClose", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (user) {
          yield this.settings.confirmClose(user.hasDirtyAttributes);
          user.rollbackAttributes();
          this.router.transitionTo('account.overview');
        }
      }), null, "handleClose", null));
      _defineProperty(this, "handleSubmit", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (user) {
          try {
            const {
              alert
            } = yield this.settings.submitForm.perform(user.save(), 'account.overview.preferences');
            this.alerts.add(alert);
            this.updateCalendarInfo(user);
            this.handleClose.perform(user);
          } catch ({
            alert
          }) {
            this.alerts.add(alert);
          }
        }
      }), null, "handleSubmit", null));
    }
    setupController(controller) {
      controller.setProperties({
        user: this.auth.currentUserModel,
        days: (0, _days.default)(this.intl),
        handleClose: this.handleClose,
        handleSubmit: this.handleSubmit
      });
    }
    updateCalendarInfo(_ref) {
      let {
        timeZone,
        timeZoneIdentifier,
        firstDay
      } = _ref;
      this.userConfig.set('currentTimeZone', {
        name: timeZone,
        identifier: timeZoneIdentifier
      });
      this.auth.set('currentFirstDay', firstDay);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
});